import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { AffiliateData } from '../payment.types';

const getAffiliateLog = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<AffiliateData[]>>('/affiliatelog')).data;
};

export const affiliateLogQueries = {
  all: () => ['/affiliatelog'],

  list: () =>
    queryFactoryOptions<ApiResponse<AffiliateData[]>>({
      queryKey: [...affiliateLogQueries.all(), 'list'],
      queryFn: (client) => getAffiliateLog(client),
    }),
};
